import { RadioField } from '@petsmart-ui/sparky';

import { usePageLayout } from '@libs/common-next';
import type { SelectedVariantKeys, VariantValue } from '@libs/algolia';

import { useInStockProductVariant } from '@app/pdp/hooks/useInStockProductVariant';
import { useInventories } from '@app/pdp/entities/inventories';

type ProductVariantRadioFieldProps = {
    variantKey: SelectedVariantKeys;
} & Omit<VariantValue, 'key'>;

export default function ProductVariantRadioField({
    value,
    display,
    variantKey,
}: ProductVariantRadioFieldProps) {
    const { selectedStore } = usePageLayout();
    const stock = useInStockProductVariant(variantKey, value, selectedStore);

    const { isLoading: inventoryLoading } = useInventories();

    return (
        <RadioField.Item
            data-testid={`variant-button-${value}`}
            diagonalStrikethrough={!stock}
            text={display ?? value}
            value={value}
            disabled={inventoryLoading}
        />
    );
}
